export default __webpack_public_path__ + "images/f55f5e2831a55bfb8c95299033dff66e-back-button.svg";